
export type SystemRole =
  | 'user'
  | 'agent'
  | 'senior_agent'
  | 'approver'
  | 'admin'
  | 'mailing_editor';

export type AppRole = string;

export const SYSTEM_ROLES: SystemRole[] = [
  'user',
  'agent',
  'senior_agent',
  'approver',
  'admin',
  'mailing_editor',
];

export const SYSTEM_ROLE_LABELS: Record<SystemRole, string> = {
  user: 'Пользователь',
  agent: 'Агент',
  senior_agent: 'Старший агент',
  approver: 'Согласующий',
  admin: 'Администратор',
  mailing_editor: 'Редактор рассылок',
};

export const KEYCLOAK_GROUP_TO_ROLE: Record<string, SystemRole> = {
  'service-desk/users': 'user',
  'service-desk/agents': 'agent',
  'service-desk/senior-agents': 'senior_agent',
  'service-desk/approvers': 'approver',
  'service-desk/admins': 'admin',
  'service-desk/mailing-editors': 'mailing_editor',
  'service-desk-developer': 'admin',
};

export const REALM_ROLE_TO_APP_ROLE: Record<string, SystemRole> = {
  user: 'user',
  agent: 'agent',
  senior_agent: 'senior_agent',
  approver: 'approver',
  admin: 'admin',
};

export const ROLE_PERMISSIONS: Record<SystemRole, string[]> = {
  user: ['create_ticket'],
  agent: [
    'use_ai_assistant',
    'view_tickets',
    'create_ticket',
    'assign_ticket',
    'reassign_ticket',
    'reassign_group',
    'change_status',
    'view_ticket_chat',
    'can_add_chat_participants',
    'view_full_ticket_history',
    'view_internal_groups',
    'view_user_profiles',
    'view_sprints',
    'work_on_own_tasks',
  ],
  senior_agent: [
    'view_tickets',
    'create_ticket',
    'assign_ticket',
    'reassign_ticket',
    'reassign_group',
    'change_status',
    'view_ticket_chat',
    'can_add_chat_participants',
    'view_full_ticket_history',
    'view_internal_groups',
    'view_user_profiles',
    'rate_ticket_complexity',
    'view_sprints',
    'manage_sprints',
    'work_on_own_tasks',
    'plan_sprint',
  ],
  approver: [
    'view_tickets',
    'approve_ticket',
    'reject_ticket',
    'view_ticket_chat',
    'view_full_ticket_history',
    'view_internal_groups',
  ],
  admin: [
    'use_ai_assistant',
    'view_tickets',
    'create_ticket',
    'assign_ticket',
    'reassign_ticket',
    'reassign_group',
    'change_status',
    'view_ticket_chat',
    'can_add_chat_participants',
    'approve_ticket',
    'reject_ticket',
    'delete_ticket',
    'manage_users',
    'manage_mailings',
    'manage_workflow',
    'manage_categories',
    'manage_role_permissions',
    'manage_shared_templates',
    'manage_clients',
    'manage_service_catalogs',
    'manage_error_log',
    'view_full_ticket_history',
    'view_internal_groups',
    'view_user_profiles',
    'rate_ticket_complexity',
    'manage_kpi',
    'manage_wiki',
    'manage_approval_committees',
    'manage_key_users',
    'manage_api_keys',
    'manage_all_api_keys',
    'view_audit_log',
    'view_sprints',
    'manage_sprints',
    'view_all_sprints',
    'work_on_own_tasks',
    'plan_sprint',
  ],
  mailing_editor: ['view_tickets', 'manage_mailings', 'view_internal_groups'],
};

export const VALID_APP_ROLES: SystemRole[] = SYSTEM_ROLES;
